module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter_head_note"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("“I believe in "), _c('em', [_vm._v("living")]), _vm._v(" with the camera, and not "), _c('em', [_vm._v("using")]), _vm._v(" the camera. Suddenly, if you are working a lot, it takes over and then you see meaning in everything. You don’t have to push for it. That’s what I mean by the visual life. Very rare.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/21endnotes#ien1",
      "id": "en1"
    }
  }, [_vm._v("1")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bf403ed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06-frontmattera.vue
// module id = 72
// module chunks = 0